import { Body, Controller, Post, UploadedFile, UploadedFiles, UseInterceptors } from '@nestjs/common';
import { ApiBody, ApiConsumes } from '@nestjs/swagger';
import { GlobalResponseObject } from '@shahi-analytics/backend-utils';
import { DayLineWiseCompletedGarmentsResponse, LineDowntimeResponse, LineOperationEfficiencyResponse, LineOpportunityOperationsResponse, LineSmvResponse, LineWorkStationReworkResponse, LineWorkstationEfficiencyResponse, LinesInUnitResponse, OperationCompletionResponse, OperatorReworkResponse, PlannedActualRejGarmentsResponse, StyleOperationsTimeConsResponse, StylesResponse, UnitResponse, UnitsAbstractInfoResponse } from '@shahi-analytics/shared-models';
import { InaService } from './ina.service';
import { UnitLineDateRequest } from './request/unit-line-date.request';
import { InaHelperService } from './ina.helper.service';
import { InaImageService } from './ina-image.service';
import { FilesInterceptor, FileInterceptor} from '@nestjs/platform-express';
import { CentralInaInfoService } from './central-ina-info.service';
import { UnitLineDateRangeRequest } from './request/unit-lins-date-range.request';
import { UnitDateHourRequest } from '../migration/models/unit-date-hour.request';

const util = require('util');

export class ImageUploadModel {
  formContent: string; 
  files: any[];
}

@Controller('ina')
export class InaController {
  constructor(private readonly inaService: InaService,
      private inaHelperService: InaHelperService,
      private inaCentralService: CentralInaInfoService,
      private inaImageService: InaImageService) { }

  /**
   * 
   * @param req 
   * @returns 
   */
  @Post('/getAllUnits')
  async getAllUnits(): Promise<UnitResponse> {
    try {
      return await this.inaHelperService.getAllUnits();
    } catch (error) {
      console.log('-----------------------------------------');
      console.log(error);
      return new GlobalResponseObject(false, 0, error?.toString());
    }
  }


  /**
   * 
   * @param req 
   * @returns 
   */
  @ApiBody({ type: UnitLineDateRequest })
  @Post('/getGarmentsPlanAndActualInfo')
  async getGarmentsPlanAndActualInfo(@Body() req: any): Promise<PlannedActualRejGarmentsResponse> {
    try {
      console.log(req);
      return await this.inaService.getGarmentsPlanAndActualInfo(req);
    } catch (error) {
      console.log('-----------------------------------------');
      console.log(error);
      return new GlobalResponseObject(false, 0, error?.toString());
    }
  }


  /**
   * 
   * @param req 
   * @returns 
   */
  @ApiBody({ type: UnitLineDateRequest })
  @Post('/getStyleAndOperationLevelTimeConsumptionDetails')
  async getStyleAndOperationLevelTimeConsumptionDetails(@Body() req: any): Promise<StyleOperationsTimeConsResponse> {
    try {
      return await this.inaService.getStyleAndOperationLevelTimeConsumptionDetails(req);
    } catch (err) {
      console.log('-----------------------------------------');
      console.log(err);
      return new GlobalResponseObject(false, 0, err?.toString());
    }
  }


  /**
   * 
   * @param req 
   */
  @ApiBody({ type: UnitLineDateRequest })
  @Post('/getHourlyLineWorkstationEfficiency')
  async getHourlyLineWorkstationEfficiency(@Body() req: any): Promise<LineWorkstationEfficiencyResponse> {
    try {
      return await this.inaService.getHourlyLineWorkstationEfficiency(req);
    } catch (error) {
      return new GlobalResponseObject(false, 0, error?.toString());
    }
  }


  /**
   * 
   * @param req 
   * @returns 
   */
  @ApiBody({ type: UnitLineDateRequest })
  @Post('/getHourlyLineWorkstationRework')
  async getHourlyLineWorkstationRework(@Body() req: any): Promise<LineWorkStationReworkResponse> {
    try {
      return await this.inaService.getHourlyLineWorkstationRework(req);
    } catch (error) {
      return new GlobalResponseObject(false, 0, error?.toString());
    }
  }


  /**
   * 5
   * gets the line wise and operation wise completed garments info
   * @param req 
   */
  @ApiBody({ type: UnitLineDateRequest })
  @Post('/getLineOperationCompletedGarment')
  async getLineOperationCompletedGarment(@Body() req: any): Promise<OperationCompletionResponse> {
    try {
      return await this.inaService.getLineOperationCompletedGarment(req);
    } catch (error) {
      console.log(error);
      return new GlobalResponseObject(false, 0, error?.toString());
    }
  }



  /**
   * 6
   * gets the line + operator + operation level rework
   *  gets the line + operator + operation level efficiency
   * @param req 
   */
  @ApiBody({ type: UnitLineDateRequest })
  @Post('/getLineOperatorOperationEfficiency')
  async getLineOperatorOperationEfficiency(@Body() req: any): Promise<OperatorReworkResponse> {
    try {
      return await this.inaService.getLineOperatorOperationEfficiency(req);
    } catch (error) {
      return new GlobalResponseObject(false, 0, error?.toString());
    }
  }

  /**
   * 
   * @param req 
   */
  @ApiBody({ type: UnitLineDateRequest })
  @Post('/getLinesInUnit')
  async getLinesInUnit(@Body() req: any): Promise<LinesInUnitResponse> {
    try {
      return await this.inaHelperService.getLinesInUnit(req);
    } catch (error) {
      return new GlobalResponseObject(false, 0, error?.toString());
    }
  }

  /**
   * 
   * @param req 
   */
  @ApiBody({ type: UnitLineDateRequest })
  @Post('/getLineOperationsEfficiency')
  async getLineOperationsEfficiency(@Body() req: any): Promise<LineOperationEfficiencyResponse> {
    try {
      return await this.inaService.getLineOperationsEfficiency(req);
    } catch (error) {
      console.log(error);
      return new GlobalResponseObject(false, 0, error?.toString());
    }
  }

  /**
   * 
   * @param req 
   */
  @ApiBody({ type: UnitLineDateRequest })
  @Post('/getLineWiseDownTimes')
  async getLineWiseDownTimes(@Body() req: any): Promise<LineDowntimeResponse> {
    try {
      return await this.inaService.getLineWiseDownTimes(req);
    } catch (error) {
      console.log(error);
      return new GlobalResponseObject(false, 0, error?.toString());
    }
  }

  /**
   * 
   * @param req 
   */
  @ApiBody({ type: UnitLineDateRequest })
  @Post('/getOpportunityOperations')
  async getOpportunityOperations(@Body() req: any): Promise<LineOpportunityOperationsResponse> {
    try {
      return await this.inaService.getOpportunityOperations(req);
    } catch (error) {
      console.log(error);
      return new GlobalResponseObject(false, 0, error?.toString());
    }
  }


  /**
   * 
   * @param req 
   * @returns 
   */
  @ApiBody({ type: UnitLineDateRequest })
  @Post('/getLineStyleGarmentAndOperationsSmv')
  async getLineStyleGarmentAndOperationsSmv(@Body() req: any): Promise<LineSmvResponse> {
    try {
      return await this.inaService.getLineStyleGarmentAndOperationsSmv(req);
    } catch (error) {
      console.log(error);
      return new GlobalResponseObject(false, 0, error?.toString());
    }
  }

  /**
   * 
   * @param req 
   * @returns 
   */
  @ApiBody({ type: UnitLineDateRequest })
  @Post('/getLineLevelAbstarctInfoForAllUnits')
  async getLineLevelAbstarctInfoForAllUnits(@Body() req: any): Promise<UnitsAbstractInfoResponse> {
    try {
      return await this.inaCentralService.getLineLevelAbstarctInfoForAllUnits(req.date);
    } catch (error) {
      console.log(error);
      return new GlobalResponseObject(false, 0, error?.toString());
    }
  }

  /**
   * 
   * @param req 
   * @returns 
   */
  @ApiBody({ type: UnitLineDateRequest })
  @Post('/getLineLevelAbstarctInfoForUnit')
  async getLineLevelAbstarctInfoForUnit(@Body() req: any): Promise<UnitsAbstractInfoResponse> {
    try {
      return await this.inaCentralService.getLineLevelAbstarctInfoForUnit(req);
    } catch (error) {
      console.log(error);
      return new GlobalResponseObject(false, 0, error?.toString());
    }
  }


  /**
   * 
   * @param req 
   * @returns 
   */
  @ApiBody({ type: UnitLineDateRequest })
  @Post('/getHourlyLineWorkstationGoodAndReworkForExternalApps')
  async getHourlyLineWorkstationGoodAndReworkForExternalApps(@Body() req: any): Promise<LineWorkStationReworkResponse> {
    try {
      return await this.inaService.getHourlyLineWorkstationGoodAndReworkForExternalApps(req);
    } catch (error) {
      return new GlobalResponseObject(false, 0, error?.toString());
    }
  }


  /**
   * gets the date wise + line wise planned and actual garments
   * @param req 
   * @returns 
   */
  @ApiBody({ type: UnitLineDateRangeRequest })
  @Post('/getLineActualAndPlanQtysForDateRange')
  async getLineActualAndPlanQtysForDateRange(@Body() req: UnitLineDateRangeRequest): Promise<DayLineWiseCompletedGarmentsResponse> {
    try {
      return await this.inaService.getLineActualAndPlanQtysForDateRange(req);
    } catch (error) {
      return new GlobalResponseObject(false, 0, error?.toString());
    }
  }

  @ApiBody({ type: UnitLineDateRequest })
  @Post('/getStylesInUnit')
  async getStylesInUnit(@Body() req: any): Promise<StylesResponse> {
    try {
      return await this.inaService.getStylesInUnit(req);
    } catch (error) {
      return new GlobalResponseObject(false, 0, error?.toString());
    }
  }

  // { 
  //   fileFilter: (req: any, file: any, cb: any) => {
  //     console.log(req.body);
  //     console.log(file);
  //     if (file.uid) {
  //         console.log(file.uid);
  //     } else {
  //         console.log('uid not found');
  //     }
  //   }
  // }

  @Post('/saveFiles')
  @UseInterceptors(FilesInterceptor('files', 50 ))
  @ApiConsumes('multipart/form-data')
  // @ApiImplicitFile({ name: 'file', required: true })
  async uploadModel(@UploadedFiles() file, @Body() modelData: any) {
    console.log(util.inspect(file, false, null, true));
    console.log(util.inspect(modelData, false, null, true));
    console.log(JSON.parse(modelData.formContent));
    const decodedData = JSON.parse(modelData.formContent);
    await this.inaImageService.saveFiles(modelData, file);
  }

}

